/**
 * MS-573 — Saudi banks list for the wallet bank-account form.
 *
 * FE-only reference data (the backend stores `BankName` as a free string). We save
 * the stable `code` and map it to a localized label everywhere it is shown, so the
 * balance card reads «مصرف الراجحي» in Arabic and "Al Rajhi Bank" in English no
 * matter which language the host used when linking the account. An unknown code
 * (e.g. one saved before this list existed) falls back to the raw stored string.
 */
export interface SaudiBank {
  code: string;
  ar: string;
  en: string;
}

export const SAUDI_BANKS: SaudiBank[] = [
  { code: "alrajhi", ar: "مصرف الراجحي", en: "Al Rajhi Bank" },
  { code: "snb", ar: "البنك الأهلي السعودي", en: "Saudi National Bank (SNB)" },
  { code: "riyad", ar: "بنك الرياض", en: "Riyad Bank" },
  { code: "alinma", ar: "مصرف الإنماء", en: "Alinma Bank" },
  { code: "sab", ar: "البنك السعودي الأول", en: "Saudi Awwal Bank (SAB)" },
  { code: "bsf", ar: "البنك السعودي الفرنسي", en: "Banque Saudi Fransi" },
  { code: "anb", ar: "البنك العربي الوطني", en: "Arab National Bank (ANB)" },
  { code: "albilad", ar: "بنك البلاد", en: "Bank Albilad" },
  { code: "aljazira", ar: "بنك الجزيرة", en: "Bank Aljazira" },
  { code: "saib", ar: "البنك السعودي للاستثمار", en: "Saudi Investment Bank (SAIB)" },
  { code: "gib", ar: "بنك الخليج الدولي", en: "Gulf International Bank (GIB)" },
  { code: "stcbank", ar: "بنك stc", en: "stc bank" },
  { code: "d360", ar: "بنك دي 360", en: "D360 Bank" },
];

/** Localized bank label for a stored code; falls back to the raw value if unknown. */
export const bankLabel = (code: string | null | undefined, language: string): string => {
  if (!code) return "";
  const match = SAUDI_BANKS.find((b) => b.code === code);
  if (!match) return code;
  return language === "ar" ? match.ar : match.en;
};
